import React, { forwardRef } from 'react';
import Typography from 'new/elements/TypographySupport';
import cx from 'classnames';
import isNil from 'lodash/isNil';
import styles from './DataSourceIcon.module.scss';
import { ReactComponent as NexsetsIcon } from 'new/components/icons/nexsetsOutline.svg';

const DataSourceIcon = forwardRef(function DataSourceIcon(
  {
    size = 's',
    icon = undefined,
    name,
    displayName = true,
    description,
    nexset = false,
    noBorder = false,
    ...restProps
  },
  ref,
) {
  const iconStyle = !icon
    ? {
        width: 0,
        marginRight: 0,
      }
    : null;

  const Icon = (() => {
    if (nexset) {
      return <NexsetsIcon className={cx(styles.icon, 'data-set-icon')} />;
    }
    if (typeof icon === 'string') {
      const altLabel = typeof label === 'string' ? label : '';
      return <img className={cx(styles.icon)} style={iconStyle} src={icon} alt={altLabel} />;
    }
    if (!!icon) return icon;
    return null;
  })();

  let hasIcon = !isNil(icon);
  const shouldDisplayName = Boolean((displayName || !hasIcon) && !nexset);

  return (
    <div className={styles.dataSourceIcon} {...restProps} ref={ref}>
      <div
        className={cx(styles.iconWrapper, styles[`SIZE${size}`], {
          [styles.isNexset]: nexset || typeof icon !== 'string',
          [styles.noIcon]: !hasIcon,
          [styles.iconNoBorder]: noBorder,
        })}
      >
        {Icon}
      </div>

      {shouldDisplayName && (
        <Typography variant="subtitle2" className="credential-type" alt={description}>
          {name}
        </Typography>
      )}
    </div>
  );
});

export default DataSourceIcon;
